
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  //  Disable console logs in production
  if (window) {
    window.console.log = () => {};
    window.console.info = () => {};
    window.console.warn = () => {};
    // window.console.error = () => {}; // Usually better to keep errors for debugging
  }
 
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
